<template>
    <div class="table table--popup choose-printer choose-printer__scroll choose-printer--project">
        <b-table  hover  :fields="fields" :items="projects" primary-key="id">
            <template v-slot:cell(select)="data">
                <b-button  @click="select(data.item.id)"
                           size="-small" variant="-ternary btn--outline">
                    Select
                </b-button>
            </template>
        </b-table>
    </div>
</template>

<script>
  export default {
    name: "ProjectListSelect",
    props: ['projects'],
    data(){
      return{
        fields: [
          {
            key: 'name',

          },
          {
            key: 'select',
            //sortable: false
          },
        ],
      }
    },
    methods:{
      select(projectId){
        this.$emit('select', projectId)
      }
    }
  }
</script>

<style lang="scss">
    .choose-printer--project {
       tr {
           height: 48px;
       }
    }
</style>
